import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["message"];
import React from 'react';
import { StylesProvider } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Dialog } from './core';
var WarningCircle = Icons.WarningCircle; // TODO: this needs to be aligned with design once the designs are finalised

var tokens = {
  dialog: {
    background: {
      color: function color(_ref) {
        var token = _ref.token;
        return token('dialog.warning.background.color', token('color.container.static.warning.contrast'));
      }
    }
  },
  button: {
    ghost: {
      hover: {
        border: {
          color: 'transparent'
        },
        background: {
          color: function color(_ref2) {
            var token = _ref2.token;
            return token('palette.tint.light.200');
          }
        }
      },
      active: {
        border: {
          color: 'transparent'
        },
        background: {
          color: function color(_ref3) {
            var token = _ref3.token;
            return token('palette.tint.light.300');
          }
        }
      }
    }
  }
};
export function WarningDialog(_ref4) {
  var message = _ref4.message,
      props = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(Dialog, _extends({
    intent: "alert",
    TitleIcon: WarningCircle
  }, props), message));
}